import { render, staticRenderFns } from "./userpic.vue?vue&type=template&id=bb520fd0&"
import script from "./userpic.vue?vue&type=script&lang=js&"
export * from "./userpic.vue?vue&type=script&lang=js&"
import style0 from "./userpic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports